module.exports = __webpack_public_path__ + "img/tele2-error-image.86181be2.svg";